// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__3f4tD","messageCol":"Table_messageCol__2yQna","tableLoading":"Table_tableLoading__3mmyD"};